import { NotificationTemplate } from "../index";

export const BankingPending: NotificationTemplate<undefined> = {
  renderTitle: () => "Banking verification in progress",
  renderBody: () =>
    "We've received your information and our team is currently reviewing it. This process typically takes less than one business day. Thank you for your patience."
};
